<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-activity" label="Automations">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <automations-list />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-mail" label="E-mail templates">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <automation-templates />
      </div>
    </vs-tab>
    <!--<vs-tab icon-pack="feather" icon="icon-map-pin" label="Overview">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <automations-overview />
      </div>
    </vs-tab>-->
  </vs-tabs>
</template>

<script>
import AutomationsList from "./AutomationsList.vue";
import AutomationsOverview from "./AutomationsOverview.vue";
import AutomationTemplates from "./EmailTemplates/EmailTemplates.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    AutomationsList,
    AutomationsOverview,
    AutomationTemplates,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>